module.exports = __webpack_public_path__ + "img/754-d8a40e.png";